var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"card-number"},[_vm._v(_vm._s(_vm.cardNumber))]),_c('div',{staticClass:"company-name"},[_vm._v(_vm._s(_vm.companyName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }